// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./allCoupons.css";

// const AllCoupons = () => {
//   const [allCoupons, setAllCoupons] = useState([]);
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   useEffect(() => {
//     fetchCoupons();
//   }, [API_BASE_URL]);

//   const formatDate = (dateString) => {
//     console.log("Formatting date:", dateString);
//     if (!dateString) return "Invalid Date";
//     const date = new Date(dateString);
//     return date.toISOString().split("T")[0];
//   };

//   const fetchCoupons = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/coupons`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       console.log(response.data);
//       setAllCoupons(response.data);
//     } catch (error) {
//       console.error("Error fetching coupons:", error);
//     }
//   };

//   const handleAddNewCoupons = () => {
//     navigate("/add-coupons");
//   };

//   const handleEdit = (id) => {
//     navigate(`/edit-coupons/${id}`);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this coupon?")) {
//       try {
//         await axios.delete(`${API_BASE_URL}/admin/coupons/${id}`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         alert("Coupon deleted successfully!");
//         fetchCoupons(); // Refresh the coupon list
//       } catch (error) {
//         console.error("Error deleting coupon:", error);
//         alert("Failed to delete the coupon. Please try again.");
//       }
//     }
//   };

//   return (
//     <div id="classes-inner-wrapper">
//       <div className="classes-header-div">
//         <h5>All Offer And Coupons</h5>
//         <div className="classes-header-btns">
//           <button className="add-class-btn" onClick={handleAddNewCoupons}>
//             + Add New Coupon
//           </button>
//           <button className="all-classes-btn" onClick={fetchCoupons}>
//             Refresh
//           </button>
//         </div>
//       </div>

//       <div className="classes-table-container">
//         <h5>All Coupons</h5>
//         <table className="classes-table">
//           <thead>
//             <tr>
//               <th>S.No.</th>
//               <th>User Type</th>
//               <th>Coupon Code</th>
//               <th>Coupon Value %</th>
//               <th>Coupon Limit</th>
//               <th>Expiry Date</th>
//               <th>Category</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {allCoupons.length > 0 ? (
//               allCoupons.map((data, idx) => (
//                 <tr key={data._id} className="box-border">
//                   <td>{idx + 1}</td>
//                   <td>{data.userType}</td>
//                   <td>{data.couponCode}</td>
//                   <td>{data.value}</td>
//                   <td>{data.limit}</td>
//                   <td>
//                     {data.expiryDate
//                       ? formatDate(data.expiryDate)
//                       : "No Expiry Date"}
//                   </td>
//                   <td>
//                     {data?.category && data?.category.length > 0
//                       ? data?.category.map((item) => <p>{item}</p>)
//                       : "N/A"}
//                   </td>
//                   <td>{data.status}</td>
//                   <td className="table-action-icons">
//                     <i
//                       className="fa-solid fa-file-pen"
//                       onClick={() => handleEdit(data._id)}
//                       style={{ cursor: "pointer", color: "blue" }}
//                     ></i>
//                     &nbsp;&nbsp;
//                     <i
//                       className="fa-solid fa-trash-can"
//                       onClick={() => handleDelete(data._id)}
//                       style={{ cursor: "pointer", color: "red" }}
//                     ></i>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5">
//                   <h1>No Data Found</h1>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default AllCoupons;





import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./allCoupons.css";

/* ---------- helpers ---------- */

const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const money = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

const formatDate = (dateString) => {
  if (!dateString) return "No Expiry Date";
  const d = new Date(dateString);
  if (isNaN(d)) return "Invalid Date";
  return d.toISOString().split("T")[0];
};

const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  if (isNaN(d)) return "-";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Exam_Notes -> Exam Notes
const prettyCategory = (c) => (c ? String(c).replace(/_/g, " ") : "N/A");

const isExpired = (dateString) => {
  if (!dateString) return false;
  const d = new Date(dateString);
  if (isNaN(d)) return false;
  const end = new Date(d);
  end.setHours(23, 59, 59, 999);
  return end < new Date();
};

// one colour per category, cycled
const PALETTE = [
  { from: "#4f8cff", to: "#1f6fe5", soft: "#e6f0ff" },
  { from: "#ff9a5c", to: "#ff5a1f", soft: "#fff0e6" },
  { from: "#34d399", to: "#12a35f", soft: "#e3f8ee" },
  { from: "#a78bfa", to: "#6d2ce5", soft: "#efe8ff" },
  { from: "#f472b6", to: "#db2777", soft: "#fde7f3" },
  { from: "#fbbf24", to: "#d98a00", soft: "#fff4d6" },
];

const EMPTY_FILTERS = { couponCode: "", userType: "", category: "", from: "", to: "" };

const AllCoupons = () => {
  const navigate = useNavigate();

  const [tab, setTab] = useState("coupons"); // coupons | usage

  // coupons
  const [allCoupons, setAllCoupons] = useState([]);
  const [couponsLoading, setCouponsLoading] = useState(false);

  // overall summary (always unfiltered, shown at the top)
  const [overall, setOverall] = useState(null);

  // usage entries (filtered + paginated)
  const [usages, setUsages] = useState([]);
  const [usageLoading, setUsageLoading] = useState(false);
  const [usageMeta, setUsageMeta] = useState({ page: 1, totalPages: 1, total: 0 });
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [appliedFilters, setAppliedFilters] = useState(EMPTY_FILTERS);
  const [filteredSummary, setFilteredSummary] = useState(null);

  /* ---------- fetchers ---------- */

  const fetchCoupons = async () => {
    setCouponsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/coupons`, authHeaders());
      const list = Array.isArray(response.data) ? response.data : response.data?.data || [];
      setAllCoupons(list);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setCouponsLoading(false);
    }
  };

  const fetchOverall = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/coupon-usage`, {
        ...authHeaders(),
        params: { limit: 1 },
      });
      setOverall(response.data?.summary || null);
    } catch (error) {
      console.error("Error fetching coupon summary:", error);
    }
  };

  const fetchUsages = async (page = 1, f = appliedFilters) => {
    setUsageLoading(true);
    try {
      const params = { page, limit: 10 };
      Object.entries(f).forEach(([k, v]) => {
        if (v) params[k] = v;
      });
      const response = await axios.get(`${API_BASE_URL}/admin/coupon-usage`, {
        ...authHeaders(),
        params,
      });
      setUsages(response.data?.data || []);
      setUsageMeta({
        page: response.data?.pagination?.page || 1,
        totalPages: response.data?.pagination?.totalPages || 1,
        total: response.data?.pagination?.total || 0,
      });
      setFilteredSummary(response.data?.summary || null);
    } catch (error) {
      console.error("Error fetching coupon usages:", error);
      setUsages([]);
    } finally {
      setUsageLoading(false);
    }
  };

  const refreshAll = () => {
    fetchCoupons();
    fetchOverall();
    fetchUsages(1, appliedFilters);
  };

  useEffect(() => {
    refreshAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------- actions ---------- */

  const handleAddNewCoupons = () => navigate("/add-coupons");
  const handleEdit = (id) => navigate(`/edit-coupons/${id}`);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      try {
        await axios.delete(`${API_BASE_URL}/admin/coupons/${id}`, authHeaders());
        alert("Coupon deleted successfully!");
        fetchCoupons();
      } catch (error) {
        console.error("Error deleting coupon:", error);
        alert("Failed to delete the coupon. Please try again.");
      }
    }
  };

  const applyFilters = () => {
    setAppliedFilters(filters);
    fetchUsages(1, filters);
  };

  const resetFilters = () => {
    setFilters(EMPTY_FILTERS);
    setAppliedFilters(EMPTY_FILTERS);
    fetchUsages(1, EMPTY_FILTERS);
  };

  const goToPage = (p) => {
    if (p < 1 || p > usageMeta.totalPages) return;
    fetchUsages(p, appliedFilters);
  };

  /* ---------- derived ---------- */

  // how many times each coupon code was used (for the coupons table)
  const usedMap = useMemo(() => {
    const map = {};
    (overall?.byCoupon || []).forEach((c) => {
      map[c._id] = c.uses;
    });
    return map;
  }, [overall]);

  const byCategory = overall?.byCategory || [];
  const maxCategoryUses = Math.max(1, ...byCategory.map((c) => c.uses));

  const categoryOptions = useMemo(() => {
    const set = new Set(byCategory.map((c) => c._id));
    allCoupons.forEach((c) => (c.category || []).forEach((x) => set.add(x)));
    return Array.from(set).filter(Boolean);
  }, [byCategory, allCoupons]);

  const hasActiveFilters = Object.values(appliedFilters).some(Boolean);

  const categoryColor = (name) => {
    const idx = Math.max(0, categoryOptions.indexOf(name));
    return PALETTE[idx % PALETTE.length];
  };

  const userName = (u) => u?.fullName || u?.name || "Deleted user";

  /* ---------- UI ---------- */

  return (
    <div className="cp-page">
      {/* ===== Header ===== */}
      <div className="cp-header">
        <div>
          <h2 className="cp-title">Offers &amp; Coupons</h2>
          <p className="cp-subtitle">Manage coupons and see exactly who is using them</p>
        </div>
        <div className="cp-header-actions">
          <button className="cp-btn cp-btn-ghost" onClick={refreshAll}>
            <i className="fa-solid fa-rotate"></i> Refresh
          </button>
          <button className="cp-btn cp-btn-primary" onClick={handleAddNewCoupons}>
            <i className="fa-solid fa-plus"></i> Add New Coupon
          </button>
        </div>
      </div>

      {/* ===== Summary cards ===== */}
      <div className="cp-stats">
        <div className="cp-stat">
          <div className="cp-stat-icon cp-grad-blue"><i className="fa-solid fa-ticket"></i></div>
          <div>
            <p className="cp-stat-label">Total coupon uses</p>
            <h3 className="cp-stat-value">{(overall?.totalUses || 0).toLocaleString("en-IN")}</h3>
          </div>
        </div>
        <div className="cp-stat">
          <div className="cp-stat-icon cp-grad-orange"><i className="fa-solid fa-indian-rupee-sign"></i></div>
          <div>
            <p className="cp-stat-label">Discount given</p>
            <h3 className="cp-stat-value">{money(overall?.totalDiscountGiven)}</h3>
          </div>
        </div>
        <div className="cp-stat">
          <div className="cp-stat-icon cp-grad-green"><i className="fa-solid fa-wallet"></i></div>
          <div>
            <p className="cp-stat-label">Collected after discount</p>
            <h3 className="cp-stat-value">{money(overall?.totalAmountPaid)}</h3>
          </div>
        </div>
        <div className="cp-stat">
          <div className="cp-stat-icon cp-grad-purple"><i className="fa-solid fa-users"></i></div>
          <div>
            <p className="cp-stat-label">Unique users</p>
            <h3 className="cp-stat-value">{(overall?.uniqueUsers || 0).toLocaleString("en-IN")}</h3>
          </div>
        </div>
      </div>

      {/* ===== Category breakdown ===== */}
      <div className="cp-card">
        <div className="cp-card-head">
          <h4>Usage by category</h4>
          <span className="cp-muted">Which sections are using coupons the most</span>
        </div>

        {byCategory.length === 0 ? (
          <div className="cp-empty-small">No coupon usage recorded yet.</div>
        ) : (
          <div className="cp-cat-grid">
            {byCategory.map((c) => {
              const color = categoryColor(c._id);
              const pct = Math.round((c.uses / maxCategoryUses) * 100);
              return (
                <div className="cp-cat" key={c._id} style={{ background: color.soft }}>
                  <div className="cp-cat-top">
                    <span className="cp-cat-name">{prettyCategory(c._id)}</span>
                    <span
                      className="cp-cat-count"
                      style={{ background: `linear-gradient(135deg, ${color.from}, ${color.to})` }}
                    >
                      {c.uses} {c.uses === 1 ? "use" : "uses"}
                    </span>
                  </div>
                  <div className="cp-bar">
                    <div
                      className="cp-bar-fill"
                      style={{
                        width: `${pct}%`,
                        background: `linear-gradient(90deg, ${color.from}, ${color.to})`,
                      }}
                    />
                  </div>
                  <div className="cp-cat-meta">
                    <span><b>{money(c.discount)}</b> discount</span>
                    <span><b>{money(c.paid)}</b> collected</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ===== Tabs ===== */}
      <div className="cp-tabs">
        <button
          className={`cp-tab ${tab === "coupons" ? "active" : ""}`}
          onClick={() => setTab("coupons")}
        >
          All Coupons <span className="cp-tab-count">{allCoupons.length}</span>
        </button>
        <button
          className={`cp-tab ${tab === "usage" ? "active" : ""}`}
          onClick={() => setTab("usage")}
        >
          Usage Entries <span className="cp-tab-count">{usageMeta.total}</span>
        </button>
      </div>

      {/* ===== Coupons tab ===== */}
      {tab === "coupons" && (
        <div className="cp-card cp-table-card">
          {couponsLoading ? (
            <div className="cp-loading"><span className="cp-spinner" /> Loading coupons…</div>
          ) : (
            <div className="cp-table-wrap">
              <table className="cp-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon</th>
                    <th>User Type</th>
                    <th>Value</th>
                    <th>Usage</th>
                    <th>Expiry</th>
                    <th>Category</th>
                    <th>Status</th>
                    <th className="cp-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {allCoupons.length > 0 ? (
                    allCoupons.map((data, idx) => {
                      const used = usedMap[data.couponCode] || 0;
                      const limit = Number(data.limit) || 0;
                      const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
                      const expired = isExpired(data.expiryDate);
                      const active = String(data.status || "").toLowerCase() === "active";
                      return (
                        <tr key={data._id}>
                          <td className="cp-muted">{idx + 1}</td>
                          <td><span className="cp-code">{data.couponCode}</span></td>
                          <td>
                            <span className={`cp-pill ${data.userType === "Teacher" ? "cp-pill-orange" : "cp-pill-blue"}`}>
                              {data.userType}
                            </span>
                          </td>
                          <td><b>{data.value}%</b></td>
                          <td className="cp-usage-cell">
                            <div className="cp-usage-text">
                              <b>{used}</b>
                              <span className="cp-muted"> / {limit || "∞"}</span>
                            </div>
                            {limit > 0 && (
                              <div className="cp-bar cp-bar-thin">
                                <div
                                  className="cp-bar-fill"
                                  style={{
                                    width: `${pct}%`,
                                    background: pct >= 90
                                      ? "linear-gradient(90deg,#fb7185,#e11d48)"
                                      : "linear-gradient(90deg,#4f8cff,#1f6fe5)",
                                  }}
                                />
                              </div>
                            )}
                          </td>
                          <td>
                            {data.expiryDate ? (
                              <>
                                {formatDate(data.expiryDate)}
                                {expired && <span className="cp-pill cp-pill-red cp-ml">Expired</span>}
                              </>
                            ) : (
                              <span className="cp-muted">No Expiry Date</span>
                            )}
                          </td>
                          <td>
                            {data?.category && data.category.length > 0 ? (
                              <div className="cp-chips">
                                {data.category.map((item) => (
                                  <span className="cp-chip" key={item}>{prettyCategory(item)}</span>
                                ))}
                              </div>
                            ) : (
                              <span className="cp-muted">N/A</span>
                            )}
                          </td>
                          <td>
                            <span className={`cp-pill ${active ? "cp-pill-green" : "cp-pill-gray"}`}>
                              <span className="cp-dot" /> {data.status}
                            </span>
                          </td>
                          <td className="cp-right">
                            <button className="cp-icon-btn cp-icon-edit" title="Edit" onClick={() => handleEdit(data._id)}>
                              <i className="fa-solid fa-file-pen"></i>
                            </button>
                            <button className="cp-icon-btn cp-icon-delete" title="Delete" onClick={() => handleDelete(data._id)}>
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="cp-empty">
                          <i className="fa-solid fa-ticket"></i>
                          <h4>No coupons yet</h4>
                          <p>Create your first coupon to start offering discounts.</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ===== Usage entries tab ===== */}
      {tab === "usage" && (
        <>
          {/* filters */}
          <div className="cp-card cp-filters">
            <div className="cp-field">
              <label>Coupon code</label>
              <input
                type="text"
                placeholder="e.g. SAVE20"
                value={filters.couponCode}
                onChange={(e) => setFilters({ ...filters, couponCode: e.target.value })}
                onKeyDown={(e) => e.key === "Enter" && applyFilters()}
              />
            </div>
            <div className="cp-field">
              <label>User type</label>
              <select
                value={filters.userType}
                onChange={(e) => setFilters({ ...filters, userType: e.target.value })}
              >
                <option value="">All</option>
                <option value="Student">Student</option>
                <option value="Teacher">Teacher</option>
              </select>
            </div>
            <div className="cp-field">
              <label>Category</label>
              <select
                value={filters.category}
                onChange={(e) => setFilters({ ...filters, category: e.target.value })}
              >
                <option value="">All</option>
                {categoryOptions.map((c) => (
                  <option key={c} value={c}>{prettyCategory(c)}</option>
                ))}
              </select>
            </div>
            <div className="cp-field">
              <label>From</label>
              <input
                type="date"
                value={filters.from}
                onChange={(e) => setFilters({ ...filters, from: e.target.value })}
              />
            </div>
            <div className="cp-field">
              <label>To</label>
              <input
                type="date"
                value={filters.to}
                onChange={(e) => setFilters({ ...filters, to: e.target.value })}
              />
            </div>
            <div className="cp-filter-actions">
              <button className="cp-btn cp-btn-primary" onClick={applyFilters}>
                <i className="fa-solid fa-filter"></i> Apply
              </button>
              <button className="cp-btn cp-btn-ghost" onClick={resetFilters}>Reset</button>
            </div>
          </div>

          {/* result strip when filters are on */}
          {hasActiveFilters && filteredSummary && (
            <div className="cp-result-strip">
              <span><b>{filteredSummary.totalUses}</b> uses</span>
              <span><b>{money(filteredSummary.totalDiscountGiven)}</b> discount given</span>
              <span><b>{money(filteredSummary.totalAmountPaid)}</b> collected</span>
              <span><b>{filteredSummary.uniqueUsers}</b> users</span>
            </div>
          )}

          <div className="cp-card cp-table-card">
            {usageLoading ? (
              <div className="cp-loading"><span className="cp-spinner" /> Loading entries…</div>
            ) : (
              <>
                <div className="cp-table-wrap">
                  <table className="cp-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>User</th>
                        <th>Coupon</th>
                        <th>Category</th>
                        <th className="cp-right">Discount</th>
                        <th className="cp-right">Paid</th>
                        <th>Used on</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usages.length > 0 ? (
                        usages.map((u, idx) => {
                          const color = categoryColor(u.category);
                          return (
                            <tr key={u._id}>
                              <td className="cp-muted">
                                {(usageMeta.page - 1) * 10 + idx + 1}
                              </td>
                              <td>
                                <div className="cp-user">
                                  <div className="cp-avatar">
                                    {userName(u.userId).charAt(0).toUpperCase()}
                                  </div>
                                  <div>
                                    <div className="cp-user-name">{userName(u.userId)}</div>
                                    <div className="cp-user-sub">
                                      <span className={`cp-pill cp-pill-sm ${u.userType === "Teacher" ? "cp-pill-orange" : "cp-pill-blue"}`}>
                                        {u.userType}
                                      </span>
                                      {u.userId?.email || u.userId?.mobile || ""}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td><span className="cp-code">{u.couponCode}</span></td>
                              <td>
                                <span
                                  className="cp-chip"
                                  style={{ background: color.soft, color: color.to }}
                                >
                                  {prettyCategory(u.category)}
                                </span>
                              </td>
                              <td className="cp-right cp-money-off">- {money(u.discountAmount)}</td>
                              <td className="cp-right"><b>{money(u.finalAmount)}</b></td>
                              <td className="cp-muted">{formatDateTime(u.createdAt)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="7">
                            <div className="cp-empty">
                              <i className="fa-solid fa-receipt"></i>
                              <h4>No usage entries found</h4>
                              <p>{hasActiveFilters ? "Try changing or resetting the filters." : "Entries appear here after a student or teacher pays with a coupon."}</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {usageMeta.totalPages > 1 && (
                  <div className="cp-pagination">
                    <button
                      className="cp-btn cp-btn-ghost"
                      disabled={usageMeta.page <= 1}
                      onClick={() => goToPage(usageMeta.page - 1)}
                    >
                      <i className="fa-solid fa-chevron-left"></i> Prev
                    </button>
                    <span className="cp-page-info">
                      Page <b>{usageMeta.page}</b> of <b>{usageMeta.totalPages}</b>
                    </span>
                    <button
                      className="cp-btn cp-btn-ghost"
                      disabled={usageMeta.page >= usageMeta.totalPages}
                      onClick={() => goToPage(usageMeta.page + 1)}
                    >
                      Next <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AllCoupons;